import { render, staticRenderFns } from "./ModalInibirRestricoesEmLoteCdaWa.vue?vue&type=template&id=45f9fee7&lang=pug"
import script from "./ModalInibirRestricoesEmLoteCdaWa.vue?vue&type=script&lang=js"
export * from "./ModalInibirRestricoesEmLoteCdaWa.vue?vue&type=script&lang=js"
import style0 from "./ModalInibirRestricoesEmLoteCdaWa.vue?vue&type=style&index=0&id=45f9fee7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports